import { http } from '@/shared/api'
import type { ApiSingleResponse } from '@/shared/api'
import type { ReadOptions } from '@/shared/lib'
import { API } from '@/apps/adok/shared/api'

import type { Account } from '../model/types'

export interface AccountAdminFlags {
  frozen: boolean
  allowedPayments: string
}

/**
 * Hand-written rather than `createEntityApi`: these are two verbs on the account in
 * session, not REST over a collection, and neither takes a body.
 */
export const toggleFrozen = () =>
  http.post<ApiSingleResponse<AccountAdminFlags>>(API.adminToggleFrozen)

export const togglePayments = () =>
  http.post<ApiSingleResponse<AccountAdminFlags>>(API.adminTogglePayments)

export const getAccount = (options?: ReadOptions) =>
  http.get<ApiSingleResponse<Account>>(API.account, { signal: options?.signal })

export const requestCall = (channel: string) =>
  http.post<ApiSingleResponse<Account>>(API.accountRequestCall, { channel })

export const requestMarketplace = () =>
  http.post<ApiSingleResponse<Account>>(API.accountRequestMarketplace)

export const acceptTerms = () =>
  http.post<ApiSingleResponse<Account>>(API.accountAcceptTerms)

export const dismissSystemMessage = () =>
  http.delete<ApiSingleResponse<Account>>(API.accountSystemMessage)
